// extracted by mini-css-extract-plugin
export default {"copyEmail":"CopyEmail_copyEmail__GtWqD","header":"CopyEmail_header__bQNhw","title":"CopyEmail_title__6lxwH","copy":"CopyEmail_copy__cBB6W","disabled":"CopyEmail_disabled__jpf7T"};